import React from "react";
import Wizard from './wizard';

export default class MainComponent extends React.Component {
    render(){
        return (
          <div className="main-content container-fluid">
            <Wizard />
          </div>
        );
    }
}
